import { formatAccountingCurrency } from '../../../../../common/functions/formatters/formatAccountingCurrency';
import { formatBasisPoints } from '../../../../../common/functions/formatters/formatBasisPoints';
import { formatPercent } from '../../../../../common/functions/formatters/formatPercent';

type Value = number | null | undefined;

// Column formats, shared by the cells and the footer.
export const outstandingLoanFormats = {
    oneYearTreasuryRate: (value: Value) => formatPercent(value, 2),
    rate: (value: Value) => formatPercent(value, 1, 2),
    adjustmentRate: (value: Value) => (value === 0 ? '-' : formatPercent(value, 2)),
    servicingRate: (value: Value) => formatPercent(value, 2),
    ltv: (value: Value) => formatPercent(value, 0),
    currency: formatAccountingCurrency,
    credit: formatBasisPoints,
};
